export default __webpack_public_path__ + "static/media/detailed reporting.bf3430ef.png";